var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-tabs",
            {
              model: {
                value: _vm.active,
                callback: function ($$v) {
                  _vm.active = $$v
                },
                expression: "active",
              },
            },
            [
              _c("v-tab", [_c("h6", [_vm._v("Contacts")])]),
              _vm._v(" "),
              _vm.showSSO
                ? _c("v-tab", [_c("h6", [_vm._v("Single Sign-On")])])
                : _vm._e(),
              _vm._v(" "),
              _c("v-tab-item", [_c("org-contacts")], 1),
              _vm._v(" "),
              _c("v-tab-item", [_c("sso")], 1),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }